import React, { Component } from "react";
import { Button, DialogActions, TextField } from "@material-ui/core";

import { DialogTitle, DialogContent } from "@material-ui/core";

import { _ } from "js/vendor";
import { app } from "js/namespaces";
import { Slide } from "js/core/models/slide";
import DummyAdapter from "js/core/storage/dummyAdapter";

import { Gap10 } from "js/react/components/Gap";
import { Field } from "js/react/components/UiComponents";
import { TagsList } from "js/editor/TeamResources/TeamSlideDialog";
import AddLibraryTagsDialog from "js/react/views/UserOptions/dialogs/AddLibraryTagsDialog";
import { BeautifulDialog, ShowDialog, ShowErrorDialog, ShowWarningDialog } from "js/react/components/Dialogs/BaseDialog";
import FetchingClickShield from "js/react/components/FetchingClickShield";

export class CreateSharedSlideDialog extends Component {
    state = {
        name: "",
        description: "",
        tags: [],
        fetching: false
    }

    handleAddTag = () => {
        ShowDialog(AddLibraryTagsDialog, {
            activeTags: this.state.tags,
            acceptCallback: newTags => {
                this.setState(({ tags }) => ({
                    tags: [...new Set([...tags, ...newTags])]
                }));
            },
        });
    }

    handleRemoveTag = inputTag => {
        this.setState(({ tags }) => ({ tags: tags.filter(tag => tag !== inputTag) }));
    }

    handleConfirm = async () => {
        const { slide, presentation, onBeforeSaveSlide, closeDialog } = this.props;
        const { name, description, tags } = this.state;

        if (name.trim() == "") {
            return ShowErrorDialog({ title: "Please enter a name for your team slide" });
        }

        try {
            this.setState({ fetching: true });

            let createdSlide;
            // If the slide is not saved then will create and save a new slide
            if (slide.adapter instanceof DummyAdapter) {
                const slideAttributes = _.cloneDeep(slide.attributes);
                delete slideAttributes.id;
                delete slideAttributes.presentationId;
                delete slideAttributes.libraryItemId;
                createdSlide = new Slide(slideAttributes, { userId: app.user.id, autoSync: false });
                await slide.load();
            } else {
                createdSlide = slide;
            }

            // Before committing a slide, perform any updates
            onBeforeSaveSlide && onBeforeSaveSlide(createdSlide);

            // If updating an existing slide then we'll wait for the changes to propagate to the slide
            const slideUpdatePromise = createdSlide === slide
                ? new Promise(resolve => createdSlide.once("change:libraryItemId", resolve))
                : Promise.resolve();

            const libraryItemModel = {
                name, description,
                tags: tags.reduce((tags, tag) => ({ ...tags, [tag]: true }), {}),
                type: "slides",
                usedInPresentations: presentation ? {
                    [presentation.id]: true
                } : null,
                contentId: createdSlide.id,
                usedByUsers: {
                    [app.user.id]: true
                },
            };
            await app.appState.currentTeam.libraryItems.createLibraryItem(libraryItemModel, createdSlide, app.appState.orgId);

            // Wait for the changes to propagate (if needed)
            await slideUpdatePromise;

            closeDialog();
        } catch (err) {
            this.setState({ fetching: false });
            ShowWarningDialog({ title: "An error occurred while sharing your slide", message: err });
        }
    }

    render() {
        const { closeDialog } = this.props;
        const { name, description, tags, fetching } = this.state;

        return (
            <BeautifulDialog closeDialog={closeDialog} maxWidth="md" fullWidth preventClose={fetching}>
                <FetchingClickShield visible={fetching} backgroundColor="rgba(255, 255, 255, 0.7)" />
                <DialogTitle>Are you sure you want to share this slide with your team?</DialogTitle>
                <DialogContent style={{ paddingLeft: 100, overflowY: "hidden" }}>
                    <Field title="Slide Name">
                        <TextField
                            id="slide-name"
                            value={name}
                            placeholder="Enter a name for the team slide"
                            fullWidth
                            onChange={event => this.setState({ name: event.target.value })}
                        />
                    </Field>
                    <Field title="Add a description or instructions for this slide (optional)">
                        <TextField multiline
                            fullWidth
                            value={description}
                            placeholder="Type a description here"
                            onChange={event => this.setState({ description: event.target.value })}
                            inputProps={{
                                onBlur: event => this.setState({ description: event.target.value })
                            }}
                        />
                    </Field>
                    <Field title="Add Tags for easier searching (optional)">
                        <Gap10 />
                        <TagsList
                            tags={tags}
                            onRemove={this.handleRemoveTag}
                            onClick={this.handleAddTag}
                        />
                    </Field>
                </DialogContent>

                <DialogActions>
                    <Button id="cancelButton" onClick={closeDialog}>
                        Cancel
                    </Button>
                    <Button id="okButton" onClick={this.handleConfirm} color="primary">
                        Share Slide
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
